export default "__VITE_ASSET__XI$Pym8C__"